"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockStyling = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var inversify_react_1 = require("inversify-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var commonBlockOptions_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonBlockOptions");
var BlockStyleStore_1 = require("Project/Stores/BlockStyleStore");
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var splashConfig_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/splashConfig");
var Animation_1 = require("./Animation");
var Types_1 = require("@CommonFrontendBackend/Account/Types");
exports.BlockStyling = (0, mobx_react_1.observer)(function () {
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var stylePermissionStore = (0, inversify_react_1.useInjection)("stylePermissionStore");
    var withMotion = stylePermissionStore.allowStyle(Types_1.StyleAccessType.Motion);
    var blockStyleStore = blockStore.blockStyleStore;
    var blockStyleModel = (0, BlockStyleStore_1.getNonSourceBlockStyle)(blockStyleStore);
    var blockWidth = blockStyleModel.blockWidth, blockSpacing = blockStyleModel.blockSpacing, blockType = blockStyleModel.blockType;
    var spacingOptions = blockType === BlockTypes_1.BlockType.Splash ? splashConfig_1.splashBlockSpacingOptions : commonBlockOptions_1.blockSpacingOptions;
    function sendTelemetry(parameters) {
        telemetry.trackOnly("Block Styles Shortcuts Changed", __assign({ block_styles_shortcuts_type: blockStore.blockType }, parameters), {
            blockIntercom: true,
        });
    }
    return (react_1.default.createElement(kaleidoscope_1.Stack, { paddingLeft: "l", paddingRight: "l", paddingTop: "m", paddingBottom: "s", gap: "m" },
        react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Width", size: kaleidoscope_1.SegmentedControlSize.Medium, options: commonBlockOptions_1.blockWidthOptions, selectedValue: blockWidth, onClickHandler: function (value) {
                blockStyleStore.setStylePropsByKey("blockWidth", value);
                sendTelemetry({
                    block_styles_shortcuts_block_width: value,
                });
            } }),
        react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Block spacing", size: kaleidoscope_1.SegmentedControlSize.Medium, options: spacingOptions, selectedValue: blockSpacing, onClickHandler: function (value) {
                blockStyleStore.setStylePropsByKey("blockSpacing", value);
                sendTelemetry({
                    block_styles_shortcuts_block_spacing: value,
                });
            } }),
        blockType === BlockTypes_1.BlockType.Text && (react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Minimum height", size: kaleidoscope_1.SegmentedControlSize.Medium, options: commonBlockOptions_1.blockHeightOptions, selectedValue: blockStyleModel.blockHeight || "none", onClickHandler: function (value) {
                blockStyleStore.setStylePropsByKey("blockHeight", value);
                sendTelemetry({
                    block_styles_shortcuts_block_height: heightTelemetryMapping[blockStyleModel.blockHeight],
                });
            } })),
        withMotion && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(kaleidoscope_1.Separator, null),
            react_1.default.createElement(Animation_1.Animation, null)))));
});
var heightTelemetryMapping = (_a = {},
    _a["small"] = "1/3",
    _a["medium"] = "1/2",
    _a["large"] = "full",
    _a["none"] = "none",
    _a);
